// extracted by mini-css-extract-plugin
export default {"input":"InputGenerate_input__tN+Yc","container":"InputGenerate_container__aC6NI","generate_button":"InputGenerate_generate_button__GdA7T"};